import { Box, Button, Typography } from '@mui/material';
import { memo, useEffect, useRef } from 'react';
import * as React from 'react';
import { UploadFileRounded, CheckCircleOutline, ErrorOutline } from '@mui/icons-material'

export type FileInputProps = {  
  name?: string;
  fileList: File[];
  onChange(event: React.ChangeEvent<HTMLInputElement>): void;
  fileLoaded: boolean;
  fileType?: 'image' | 'dox';
  error?: boolean;
};
export const FileInput = memo(({ 
  name, 
  fileList=[], 
  onChange, 
  fileLoaded, 
  fileType='dox',
  error=false 
}: FileInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
      if (inputRef.current) {
        const dataTransfer = new DataTransfer();
        fileList.forEach((file) => (
          dataTransfer.items.add(file)
        ))
        inputRef.current.files = dataTransfer.files;
      }
  }, [fileList]);

  return (
    <Box display="flex">
      <Box display='flex' flexDirection='column' justifyContent='center'>
        <CheckCircleOutline sx={{display:fileLoaded ? 'block' : 'none', color:'green'}}/>
      </Box>
      <Box display='flex' flexDirection='column' justifyContent='center'>
        <ErrorOutline sx={{display:error ? 'block' : 'none', color:'red'}}/>
      </Box>
      <Box display='flex' flexDirection='column'>
        <Button
            sx={{
              color:'darkgrey',
              fontFamily:'B Nazanin', 
              fontSize:14 , 
              fontWeight:600,
              borderBottom:error ? '1px solid red' : '0px solid grey', 
            }}
            onClick={() => inputRef.current && inputRef.current.click()}
        >
        بارگذاری فایل
        <UploadFileRounded color='info' sx={{size:'large'}}/>
        <input
            data-testid="uploader"
            name={name}
            type="file"
            accept={fileType === 'dox' ? '.doc(*.doc), .docx, .xls, .xlsx(*.xlsx), .txt, application/pdf, .mpp, .xer' : ".png, .gif, jpeg, .jpg, .jpe, .bmp, .jfif, .jif"}
            // hidden
            ref={inputRef}
            style={{ display: "none" }}
            onChange={onChange}
        />
        </Button>
        {error &&
          <Typography variant='caption' color='red' sx={{fontFamily:'B Nazanin', textAlign:'right'}}>
            بارگذاری فایل الزامی می باشند
          </Typography>
        }
      </Box>
    </Box>
  );
}
)

